<template>
    <div>
      <!-- Body -->
      <div class="body">
        <div>
            <themed-table 
              :headers="this.bedManagerService.selectedJob.headers" 
              :data="transformedData" 
              :sortingEnabled=true 
              :localSorting=true
              :filteringEnabled=false
              :paginationEnabled="false" 
              @searchChange="(event) => {}"
              @sortingChange="(event) => {
                localSorting = event;
              }"
              ></themed-table>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import VueToast from "vue-toast-notification";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import ThemedTable from "../../../shared/careai/components/ThemedTable.vue";
  import BedManagerService from "../BedManager.service";

  const moment = require("moment");
  
  Vue.use(VueToast);
  Vue.use(Loading);
  Vue.component('themed-table', ThemedTable);
  
  export default {
    name: "Job",
    components: { },
    data() {
      return {
        console: console,
        moment: moment,
        // Singleton Pattern Service
        // Contains State and API Requests
        bedManagerService: BedManagerService,
        localSorting: {},
      };
    },
    computed: {
      transformedData() {
        return this.sortByKey(this.bedManagerService.selectedJob.data, this.localSorting.type,  this.localSorting.direction)
      },
      currentQuery() {
        if (this.bedManagerService.jobs.query) {
            return this.bedManagerService.jobs.query;
        }
        return null;
      },
    },
    watch: {
        currentQuery(newQuery, oldQuery) {
          this.bedManagerService.fetchJobs();
        },
    },
    mounted() {},
    unmounted() {},
    methods: {
      sortByKey(arr, key, order = 'asc') {
        return [...arr].sort((a, b) => {
            let x = a[key];
            let y = b[key];

            // Normalize undefined/null
            if (x == null) x = '';
            if (y == null) y = '';

            // Compare numbers if both look numeric
            const nx = parseFloat(x);
            const ny = parseFloat(y);
            const bothNumeric = !isNaN(nx) && !isNaN(ny);

            let cmp = 0;
            if (bothNumeric) {
            cmp = nx - ny;
            } else {
            cmp = String(x).localeCompare(String(y), undefined, { numeric: true, sensitivity: 'base' });
            }

            return order.toLowerCase() === 'desc' ? -cmp : cmp;
        });
      },
    },
  };
  </script>
  
  <!-- Header Styles -->
  <style lang="scss" scoped>
    .page-header {
      &__flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics-item {
        font-size: .7em;
        display: flex;
        flex-direction: column;
      }
    }

    .body {
        &__inner {
            padding: 15px;
        }
    }
  </style>  
  
  <style>
  ::-webkit-scrollbar {
    width: 6px; 
    height: 6px;
  }</style>
  